/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_SessionInputs */

const en_entity_session = /** @type {(inputs: Entity_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session`)
};

const de_entity_session = /** @type {(inputs: Entity_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzung`)
};

/**
* | output |
* | --- |
* | "Session" |
*
* @param {Entity_SessionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_session = /** @type {((inputs?: Entity_SessionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_SessionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_session(inputs)
	return de_entity_session(inputs)
});